import React, { useState } from "react";
import "./mobileNavbar.scss";
import Link from "next/link";
import Image from "next/image";
import { IoIosCloseCircle } from "react-icons/io";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { animateScroll as scroll } from "react-scroll";
import { usePathname } from "next/navigation";

import close from "@/../public/credits/close.png";
import profile from "@/../public/profile/profile.png";
import { allRoutes } from "@/data/allRoutes";

export default function MobileNavbar({
  setIsShowSidebar,
  isShowSidebar,
  setIsProfileOpen,
  isUserPresent,
  setShowCommingSoonModal,
  selector,
  path,
}) {
  const [showProductsDropDown, setShowProductsDropDown] = useState(false);
  const [showLegalDropDown, setShowLegalDropDown] = useState(false);
  const pathname = usePathname();

  const handleContactScroll = () => {
    if (selector.contact) {
      console.log("working");
      scroll.scrollTo(selector.contact.offsetTop - 100, {
        duration: 500,
        smooth: "easeInOutQuart",
      });
    }
  };

  return (
    <nav
      className={`MobileNavbar ${
        isShowSidebar ? "showSidebar" : ""
      }`}
    >
      <ul className="flex-row-center navLinkContainer">
        {/* products */}
        <span className="navLinks">
          <li
            onClick={() => setShowProductsDropDown((prev) => !prev)}
            className="list"
          >
            Products{" "}
            {!showProductsDropDown && (
              <RiArrowDropDownLine className="dropDownIcon" />
            )}
            {showProductsDropDown && (
              <RiArrowDropUpLine className="dropDownIcon" />
            )}
          </li>
        </span>

        {/* products dropdown */}
        {/*   {showProductsDropDown && (
          <ul className={styles.dropDownContainer}>
            <Link
              href={"/face-swap/single-ai-face-swap"}
              onClick={() => setIsShowSidebar(false)}
            >
              <li className={styles.list}>Ai Face Swap</li>
            </Link>
            <Link
              href={"/image-enhancer"}
              onClick={() => {
                setIsShowSidebar(false);
              }}
            >
              <li className={styles.list}>AI Image Inhancer</li>
            </Link>
            <div
              onClick={() => {
                setIsShowSidebar(false);
                setShowCommingSoonModal(true);
              }}
            >
              <li className={styles.list}>AI Image Generator</li>
            </div>
          </ul>
        )} */}

        <ul
          className="dropDownContainer"
          style={showProductsDropDown ? { height: "30vw" } : { height: "0" }}
        >
          <Link
            href={allRoutes.headshotGenerator}
            onClick={() => setIsShowSidebar(false)}
          >
            <li className="flex-row-center list">
              AI Headshot Generator{" "}
              <span className="navLinkIcon">New</span>
            </li>
          </Link>
          <Link
            href={`${allRoutes.faceSwap}`}
            onClick={() => setIsShowSidebar(false)}
          >
            <li className="list">AI Face Swap</li>
          </Link>
          <Link
            href={`${allRoutes.imageEnhancer}`}
            onClick={() => {
              setIsShowSidebar(false);
            }}
          >
            <li className="list">AI Image Enhancer</li>
          </Link>
          <Link
            href={`${allRoutes.imageGenerator}`}
            onClick={() => {
              setIsShowSidebar(false);
            }}
          >
            <li className="flex-row-center list">
              AI Image Generator
              <span className="navLinkIcon">New</span>
            </li>
          </Link>
        </ul>

        {/* about */}
        <Link
          href={"/about"}
          onClick={() => setIsShowSidebar(false)}
          className="navLinks"
        >
          <li className="list listX">About</li>
        </Link>

        {/* new price */}
        <Link
          href={"/pricing"}
          onClick={() => setIsShowSidebar(false)}
          className="navLinks"
        >
          <li className="list listX">Pricing</li>
        </Link>

        {/* legal */}
        <span className="navLinks">
          <li
            onClick={() => setShowLegalDropDown((prev) => !prev)}
            className="list"
          >
            Legal{" "}
            {!showLegalDropDown && (
              <RiArrowDropDownLine className="dropDownIcon" />
            )}
            {showLegalDropDown && (
              <RiArrowDropUpLine className="dropDownIcon" />
            )}
          </li>
        </span>

        {/* legal dropdown */}

        <ul
          className="dropDownContainer"
          style={showLegalDropDown ? { height: "33vw" } : { height: "0" }}
        >
          {pathname !== "/" && pathname !== "/#contact" && (
            <a
              href={"/#contact"}
              onClick={() => {
                setShowLegalDropDown(false);
                setIsShowSidebar(false);
              }}
            >
              <li onClick={handleContactScroll} className="list">
                Contact Us
              </li>
            </a>
          )}

          {(pathname === "/" || pathname === "/#contact") && (
            <div
              onClick={() => {
                handleContactScroll();
                setShowLegalDropDown(false);
                setIsShowSidebar(false);
              }}
            >
              <li onClick={handleContactScroll} className="list">
                Contact Us
              </li>
            </div>
          )}

          {/* payments policy */}
          <Link
            href={"/refund-policy"}
            onClick={() => {
              setIsShowSidebar(false);
            }}
          >
            <li className="list">Refund Policy</li>
          </Link>

          {/* privacy policy */}
          <Link
            href={"/privacy-policy"}
            onClick={() => {
              setIsShowSidebar(false);
            }}
          >
            <li className="list">Privacy Policy</li>
          </Link>

          {/* terms and conditions */}
          <Link
            href={"/terms-conditions"}
            onClick={() => {
              setIsShowSidebar(false);
            }}
          >
            <li className="list">Terms & Conditions</li>
          </Link>
        </ul>

        {/* FAQ */}
        <Link
          href={"/faq"}
          onClick={() => setIsShowSidebar(false)}
          className="navLinks lastNavLink"
        >
          <li className="list listX lastList">
            FAQ
          </li>
        </Link>

        {/* sigin */}
        {/* {!isUserPresent && (
          <Link
            href={{
              pathname: "/signin",
              query: {
                path: path,
              },
            }}
            onClick={() => setIsShowSidebar(false)}
            className={`${styles.navLink} ${styles.signIn} btn1`}
          >
            <li className={`${styles.list} ${styles.listX}`}>SignIn</li>
          </Link>
        )} */}

        {/* profile */}
        {/* {isUserPresent && (
          <div
            className={styles.profile}
            onClick={() => setIsProfileOpen((pre) => !pre)}
          >
            <img
              className={styles.userProfileImg}
              src={
                isUserPresent.photoURL == ""
                  ? profile.src
                  : isUserPresent.photoURL
              }
              alt="profile"
            />
          </div>
        )} */}
      </ul>

      {/* close */}
      <div
        onClick={() => {
          setIsShowSidebar(false);
        }}
        className="close"
      >
        <Image src={close} alt="close" />
      </div>
    </nav>
  );
}
